<template>
  <div class="grid">
    <div class="w clearfix">
      <div class="sy-sub" style="border:1px solid #ddd;">
        <div class="titleBox">
          <ul class="tit clearfix">
            <li class="current">热销商品</li>
            <li>热门关注</li>
          </ul>
          <div class="sy-item rx-sp">
            <ul class="clearfix">
              <li v-for="(item,index) in productData" :key="index">
                <router-link target="_blank" :to="'/detail1?id='+item.product_id">
                  <div class="con">
                    <img :src="item.product_img" />
                    <p>{{item.product_name}}...</p>
                  </div>
                </router-link>
              </li>
            </ul>
            <div class="gengduo">
              <a href="javascript:;">查看更多>></a>
            </div>
          </div>
          <div style="display:none" class="sy-item rm-gz">
            <ul class="clearfix">
              <li v-for="(item,index) in productData" :key="index">
                <router-link target="_blank" :to="'/detail1?id='+item.product_id">
                  <div class="con">
                    <img :src="item.product_img" />
                    <p>{{item.product_name}}...</p>
                  </div>
                </router-link>
              </li>
            </ul>
            <div class="gengduo">
              <a href="javascript:;">查看更多>></a>
            </div>
          </div>
        </div>
      </div>
      <div class="sy-main">
        <div class="sy-TabBarBox">
          <ul class="sy-tabBar clearfix">
            <li class="current">商品介绍</li>
            <!-- <li>规格参数</li>
            <li>商品评价</li> -->
          </ul>
        </div>
        <div class="sy-itemBox sy-item1">
          <div class="description productDetailImg">
            <!-- <p v-for="(item,index) in imgList" :key="index">
              <img v-lazy="item" />
            </p>-->
          </div>
        </div>
        <div style="display:none" class="sy-itemBox sy-item2">
          <div class="guige_title">
            <h1>规格参数</h1>
          </div>
          <div class="description">
            <p>
              <img src="../../assets/detail/info_img/guigecanshu.png" />
            </p>
          </div>
        </div>
        <div style="display:none" class="sy-itemBox sy-item3">
          <!-- 评分 -->
          <div class="score clearfix">
            <div class="score-left">
              <span>好评率</span>
              <h1>
                95
                <i>%</i>
              </h1>
            </div>
            <div class="yinxiang">
              <p class="line"></p>
              <p class="yx">大家印象</p>
              <p class="line"></p>
            </div>
            <div class="score-right">
              <div>
                <ul class="clearfix">
                  <li>
                    <a href="javascript:void(0)">做工一流(1200)</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">做工一流(1200)</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">做工一流(1200)</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">做工一流(1200)</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">做工一流(1200)</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">做工一流(1200)</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">做工一流(1200)</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">做工一流(1200)</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">做工一流(1200)</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 评价 -->
          <div class="comment">
            <div class="optopms clearfix">
              <el-radio v-model="radio" label="1">全部评价(3456)</el-radio>
              <el-radio v-model="radio" label="2">晒图(214)</el-radio>
              <el-radio v-model="radio" label="3">视频晒单(15)</el-radio>
              <el-radio v-model="radio" label="4">追评(201)</el-radio>
              <el-radio v-model="radio" label="5">好评(1500+)</el-radio>
              <el-radio v-model="radio" label="6">中评(12)</el-radio>
              <el-radio v-model="radio" label="7">差评(5)</el-radio>
              <div class="right">
                <el-checkbox v-model="checked">只看当前商品评价</el-checkbox>
                <select>
                  <option>默认排序</option>
                  <option>按点赞数</option>
                  <option>按好评</option>
                </select>
              </div>
            </div>
            <div class="comment-container">
              <div class="row clearfix">
                <div class="touxiang">
                  <img src="../../assets/detail/info_img/touxiang.png" />
                  <p>130****8888</p>
                </div>
                <div class="right">
                  <div class="sy-pjtop">
                    <div class="pj-top">
                      <el-rate
                        v-model="value"
                        disabled
                        show-score
                        text-color="#ff9900"
                        score-template="{value}"
                      ></el-rate>
                    </div>
                  </div>
                  <div class="sy-pjcontent">
                    <p>这个质量很好。这个质量很好这个质量很好，这个质量很好这个质量很好，这个质量很好，这个质量很好这个质量很好这个质量很好这个质量很好这个质量很好这个质量很好</p>
                    <ul class="clearfix">
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                    </ul>
                    <div class="sy-sku clearfix">
                      <div class="sku-left">
                        <span>2.5丝透明烫金不干胶_方形</span>
                        <span class="date">2019-06-24 19:41:45</span>
                      </div>
                      <div class="sku-right">
                        <a href="javascript:;">举报</a>
                        <a class="zan" href="javascript:;">
                          <img src="../../assets/detail/info_img/zan.png" />
                          <span>赞</span>
                        </a>
                        <a class="huifu" href="javascript:;">
                          <img src="../../assets/detail/info_img/huifu.png" />
                          <span>回复</span>
                        </a>
                      </div>
                    </div>
                    <div class="huifu">
                      <p class="dianpu">店铺客服回复:</p>
                      <p
                        class="hf"
                      >您的好，评您的好评您的好评您的好，评您的好评您的好评您的，好评您的好评您的好评您的好评您的好评，您的好评您的，好评您的好，评您的好评您的好评您的，好评您的好评您的好评</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row clearfix">
                <div class="touxiang">
                  <img src="../../assets/detail/info_img/touxiang.png" />
                  <p>130****8888</p>
                </div>
                <div class="right">
                  <div class="sy-pjtop">
                    <div class="pj-top">
                      <el-rate
                        v-model="value"
                        disabled
                        show-score
                        text-color="#ff9900"
                        score-template="{value}"
                      ></el-rate>
                    </div>
                  </div>
                  <div class="sy-pjcontent">
                    <p>这个质量很好。这个质量很好这个质量很好，这个质量很好这个质量很好，这个质量很好，这个质量很好这个质量很好这个质量很好这个质量很好这个质量很好这个质量很好</p>
                    <div class="shipin">
                      <video controls loop width="300px">
                        <source src="../../assets/detail/video/video.mp4" type="video/mp4" />
                      </video>
                    </div>
                    <div class="sy-sku clearfix">
                      <div class="sku-left">
                        <span>2.5丝透明烫金不干胶_方形</span>
                        <span class="date">2019-06-24 19:41:45</span>
                      </div>
                      <div class="sku-right">
                        <a href="javascript:;">举报</a>
                        <a class="zan" href="javascript:;">
                          <img src="../../assets/detail/info_img/zan.png" />
                          <span>赞</span>
                        </a>
                        <a class="huifu" href="javascript:;">
                          <img src="../../assets/detail/info_img/huifu.png" />
                          <span>回复</span>
                        </a>
                      </div>
                    </div>
                    <div class="huifu">
                      <p class="dianpu">店铺客服回复:</p>
                      <p
                        class="hf"
                      >您的好，评您的好评您的好评您的好，评您的好评您的好评您的，好评您的好评您的好评您的好评您的好评，您的好评您的，好评您的好，评您的好评您的好评您的，好评您的好评您的好评</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row clearfix">
                <div class="touxiang">
                  <img src="../../assets/detail/info_img/touxiang.png" />
                  <p>130****8888</p>
                </div>
                <div class="right">
                  <div class="sy-pjtop">
                    <div class="pj-top">
                      <el-rate
                        v-model="value"
                        disabled
                        show-score
                        text-color="#ff9900"
                        score-template="{value}"
                      ></el-rate>
                    </div>
                  </div>
                  <div class="sy-pjcontent">
                    <p>这个质量很好。这个质量很好这个质量很好，这个质量很好这个质量很好，这个质量很好，这个质量很好这个质量很好这个质量很好这个质量很好这个质量很好这个质量很好</p>
                    <ul class="clearfix">
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                    </ul>
                    <div class="sy-sku clearfix">
                      <div class="sku-left">
                        <span>2.5丝透明烫金不干胶_方形</span>
                        <span class="date">2019-06-24 19:41:45</span>
                      </div>
                      <div class="sku-right">
                        <a href="javascript:;">举报</a>
                        <a class="zan" href="javascript:;">
                          <img src="../../assets/detail/info_img/zan.png" />
                          <span>赞</span>
                        </a>
                        <a class="huifu" href="javascript:;">
                          <img src="../../assets/detail/info_img/huifu.png" />
                          <span>回复</span>
                        </a>
                      </div>
                    </div>
                    <div class="huifu">
                      <p class="dianpu">店铺客服回复:</p>
                      <p
                        class="hf"
                      >您的好，评您的好评您的好评您的好，评您的好评您的好评您的，好评您的好评您的好评您的好评您的好评，您的好评您的，好评您的好，评您的好评您的好评您的，好评您的好评您的好评</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row clearfix">
                <div class="touxiang">
                  <img src="../../assets/detail/info_img/touxiang.png" />
                  <p>130****8888</p>
                </div>
                <div class="right">
                  <div class="sy-pjtop">
                    <div class="pj-top">
                      <el-rate
                        v-model="value"
                        disabled
                        show-score
                        text-color="#ff9900"
                        score-template="{value}"
                      ></el-rate>
                    </div>
                  </div>
                  <div class="sy-pjcontent">
                    <p>这个质量很好。这个质量很好这个质量很好，这个质量很好这个质量很好，这个质量很好，这个质量很好这个质量很好这个质量很好这个质量很好这个质量很好这个质量很好</p>
                    <ul class="clearfix">
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">
                          <img src="../../assets/detail/info_img/small_xq.png" />
                        </a>
                      </li>
                    </ul>
                    <div class="sy-sku clearfix">
                      <div class="sku-left">
                        <span>2.5丝透明烫金不干胶_方形</span>
                        <span class="date">2019-06-24 19:41:45</span>
                      </div>
                      <div class="sku-right">
                        <a href="javascript:;">举报</a>
                        <a class="zan" href="javascript:;">
                          <img src="../../assets/detail/info_img/zan.png" />
                          <span>赞</span>
                        </a>
                        <a class="huifu" href="javascript:;">
                          <img src="../../assets/detail/info_img/huifu.png" />
                          <span>回复</span>
                        </a>
                      </div>
                    </div>
                    <div class="huifu">
                      <p class="dianpu">店铺客服回复:</p>
                      <p
                        class="hf"
                      >您的好，评您的好评您的好评您的好，评您的好评您的好评您的，好评您的好评您的好评您的好评您的好评，您的好评您的，好评您的好，评您的好评您的好评您的，好评您的好评您的好评</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row clearfix">
                <div class="touxiang">
                  <img src="../../assets/detail/info_img/touxiang.png" />
                  <p>130****8888</p>
                </div>
                <div class="right">
                  <div class="sy-pjtop">
                    <div class="pj-top">
                      <el-rate
                        v-model="value"
                        disabled
                        show-score
                        text-color="#ff9900"
                        score-template="{value}"
                      ></el-rate>
                    </div>
                  </div>
                  <div class="sy-pjcontent">
                    <p>这个质量很好。这个质量很好这个质量很好，这个质量很好这个质量很好，这个质量很好，这个质量很好这个质量很好这个质量很好这个质量很好这个质量很好这个质量很好</p>
                    <div class="shipin">
                      <video controls loop width="300px">
                        <source src="../../assets/detail/video/video.mp4" type="video/mp4" />
                      </video>
                    </div>
                    <div class="sy-sku clearfix">
                      <div class="sku-left">
                        <span>2.5丝透明烫金不干胶_方形</span>
                        <span class="date">2019-06-24 19:41:45</span>
                      </div>
                      <div class="sku-right">
                        <a href="javascript:;">举报</a>
                        <a class="zan" href="javascript:;">
                          <img src="../../assets/detail/info_img/zan.png" />
                          <span>赞</span>
                        </a>
                        <a class="huifu" href="javascript:;">
                          <img src="../../assets/detail/info_img/huifu.png" />
                          <span>回复</span>
                        </a>
                      </div>
                    </div>
                    <div class="huifu">
                      <p class="dianpu">店铺客服回复:</p>
                      <p
                        class="hf"
                      >您的好，评您的好评您的好评您的好，评您的好评您的好评您的，好评您的好评您的好评您的好评您的好评，您的好评您的，好评您的好，评您的好评您的好评您的，好评您的好评您的好评</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pagination">
                <el-pagination background layout="prev, pager, next" :total="100"></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: '1',
      checked: true,
      value: 5.0,
      productData: []
    }
  },
  methods: {
    async queryProductInfo() {
      const { data: res } = await this.$http.get('/api/product/hotProductList')
      this.productData = res.data
    }
  },
  mounted() {
    this.$nextTick(_ => {
      this.queryProductInfo()
    })

    $('.sy-TabBarBox').on('click', '.sy-tabBar li', function() {
      $(this)
        .addClass('current')
        .siblings('li')
        .removeClass('current')
      let index = $(this).index()

      $('.sy-itemBox')
        .eq(index)
        .fadeIn()
        .siblings('.sy-itemBox')
        .hide()
    })
    $('.sy-sub').on('click', '.tit li', function() {
      $(this)
        .addClass('current')
        .siblings('li')
        .removeClass('current')
      let index = $(this).index()
      $('.sy-item')
        .eq(index)
        .fadeIn()
        .siblings('.sy-item')
        .hide()
    })
  }
}
</script>

<style lang="less" scoped>
.grid {
  background: #fff;
  .w {
    .sy-sub {
      float: left;
      width: 218px;
      margin-right: 20px;
      .titleBox {
        .tit {
          li {
            float: left;
            width: 109px;
            height: 40px;
            box-sizing: border-box;
            border: 1px solid #ddd;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            color: #666;
            cursor: pointer;
          }
        }
        .sy-item {
          ul {
            li {
              box-sizing: border-box;
              height: 175px;
              width: 218px;
              padding: 10px;
              a {
                display: block;
                height: 100%;
                color: #666;
                .title {
                  height: 22px;
                  line-height: 22px;
                  span {
                    font-size: 14px;
                    font-style: italic;
                    color: #bbb;
                    font-weight: 700;
                    float: left;
                  }
                  strong {
                    float: right;
                    font-size: 12px;
                    color: #e83030;
                  }
                }
                .con {
                  position: relative;
                  width: 100%;
                  height: 100%;
                  img {
                    width: 100%;
                    height: 100%;
                  }
                  p {
                    position: absolute;
                    box-sizing: border-box;
                    bottom: 0;
                    left: 0px;
                    width: 100%;
                    height: 24px;
                    line-height: 24px;
                    padding: 0 12px;
                    background: #000;
                    opacity: 0.7;
                    font-size: 12px;
                    color: #fff;
                  }
                }
              }
            }
          }
          .gengduo {
            margin-top: 5px;
            height: 30px;
            width: 218px;
            background-color: #eee;
            text-align: center;
            line-height: 30px;
          }
        }

        .rm-gz {
          ul {
            li {
              background-color: #fafafa;
              height: 175px;
              a {
                .sy-ms {
                  padding: 0 10px;
                  margin-bottom: 15px;
                  p {
                    font-size: 12px;
                    color: #666;
                  }
                }
                .sy-price {
                  padding: 0 10px;
                  font-size: 12px;
                  strong {
                    float: left;
                    color: #e83030;
                  }
                  span {
                    float: right;
                    color: #999;
                  }
                }
              }
            }
          }
        }
      }
    }
    .sy-main {
      float: left;
      width: 960px;
      .sy-TabBarBox {
        height: 40px;
        background-color: #eef2f5;
        border-bottom: 1px solid #a77c5a;
        .sy-tabBar {
          li {
            float: left;
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 16px;
            cursor: pointer;
            a {
              color: #666;
            }
          }
        }
      }
      .sy-item1 {
        padding-top: 20px;
      }
      .sy-itemBox {
        .sy-youhuiquan {
          ul {
            li {
              float: left;
              margin-left: 10px;
            }
          }
        }
      }
      .sy-item2 {
        .guige_title {
          height: 60px;
          h1 {
            line-height: 60px;
            font-size: 18px;
            color: #333;
            font-weight: bold;
          }
        }
      }
      .sy-item3 {
        position: relative;
        .score {
          border: 1px solid #eee;
          width: 100%;
          height: 140px;
          padding: 10px 0;
          margin: 10px 0 20px 0;
          .score-left {
            box-sizing: border-box;
            float: left;
            width: 160px;
            height: 135px;
            padding-top: 20px;
            text-align: center;
            span {
              font-size: 14px;
              color: #999;
            }
            h1 {
              color: #e83030;
              font-size: 48px;
              margin-top: 20px;
              i {
                font-size: 24px;
              }
            }
          }
          .yinxiang {
            position: absolute;
            top: 0px;
            left: 180px;
            .line {
              width: 0;
              height: 32px;
              border: 1px solid #eee;
              margin: 5px;
            }
            .yx {
              width: 5px;
              letter-spacing: -1px;
            }
          }
          .score-right {
            position: absolute;
            top: 30px;
            left: 180px;
            margin-left: 60px;
            ul {
              li {
                float: left;
                padding: 5px 10px;
                border: 1px solid #ddd;
                text-align: center;
                margin-right: 10px;
                margin-bottom: 10px;
                a {
                  font-size: 12px;
                  color: #999;
                }
              }
            }
          }
        }
        .comment {
          .optopms {
            position: relative;
            box-sizing: border-box;
            height: 40px;
            background: #eef2f5;
            padding: 10px 12px 0 12px;
            .right {
              margin-right: 75px;
              float: right;
            }
            select {
              position: absolute;
              width: 80px;
              height: 25px;
              right: 10px;
              top: 7px;
            }
          }
          .comment-container {
            margin-top: 20px;
            .row {
              padding-top: 20px;
              border-bottom: 1px dotted #ddd;
              .touxiang {
                text-align: center;
                padding-left: 12px;
                float: left;
                img {
                  margin-bottom: 8px;
                }
              }
              .right {
                box-sizing: border-box;
                width: 855px;
                float: left;
                padding: 10px 25px;
                .sy-pjtop {
                  margin-bottom: 10px;
                }
                .sy-pjcontent {
                  ul {
                    margin: 15px 0;
                    li {
                      float: left;
                      margin-right: 10px;
                      border: 1px solid #dddddd;
                      padding: 2px;
                      a {
                        display: block;
                        width: 100%;
                      }
                    }
                  }
                  .sy-sku {
                    padding-bottom: 20px;
                    border-bottom: 1px solid #eee;
                    .sku-left {
                      float: left;
                      span {
                        font-size: 12px;
                        color: #999;
                      }
                      .date {
                        margin-left: 15px;
                      }
                    }
                    .sku-right {
                      float: right;
                      a {
                        margin-right: 20px;
                        font-size: 12px;
                        color: #999;
                        vertical-align: middle;
                        img {
                          margin-right: 5px;
                        }
                      }
                    }
                  }
                  .huifu {
                    .dianpu {
                      margin: 10px 0;
                    }
                    p {
                      font-size: 12px;
                      color: #e83030;
                    }
                  }
                }
              }
            }
            .pagination {
              margin: 18px 10px;
              float: right;
            }
          }
        }
      }
    }
  }
  .current {
    background-color: #a77c5a !important;
    color: #fff !important;
  }
}
</style>

<style lang="less">
.el-radio__input.is-checked .el-radio__inner {
  border-color: #a77c5a !important;
  background: #a77c5a !important;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #a77c5a !important;
}
.el-radio {
  margin-right: 10px !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #a77c5a !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #a77c5a !important;
  border-color: #a77c5a !important;
}
.el-checkbox__inner:hover {
  border-color: #a77c5a !important;
}
.el-radio__label {
  font-size: 12px !important;
}
.el-checkbox:last-of-type {
  margin-right: 12px !important;
}
.el-pagination.is-background .el-pager li.active {
  background-color: #a77c5a !important;
  color: #fff;
}
.el-pagination.is-background .el-pager li:hover {
  color: #a77c5a !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  border: 1px solid #ccc;
}
</style>
